import React, {Component} from 'react';
import API from "../../services/API";
import Toast from "../Common/Toast";
import { toast } from 'react-toastify';
import Actionbar from "../Common/Actionbar";
import Loading from "../Common/Loading";
const currencyFormat = Intl.NumberFormat('en-US');

class Owner extends Component {
    state = {
        owner : '',
        drivers : [],
        isLoaded: false,
        driverMoney : null,
        buttonStatus : '',
        loading: "d-none",
    }

    updatePayAmount = (id, value) => {
        let $driverMoney = this.state.driverMoney;
        if($driverMoney) {
            const findItem = $driverMoney.find(x => x.id === id);
            if(findItem) {
                const objIndex = $driverMoney.findIndex((obj => obj.id === id));
                $driverMoney[objIndex].money = value;
            }
            else {
                $driverMoney.push({'id': id, 'money': value})
            }
        }
        else {
            $driverMoney = [];
            $driverMoney.push({'id': id, 'money': value})
        }
        this.setState({driverMoney: $driverMoney})
    }
    getPayAmount = (id) => {
        let $driverMoney = this.state.driverMoney;
        if(!$driverMoney) {
            return  ''
        }
        const findItem = $driverMoney.find(x => x.id === id);
        if(findItem) {
            const objIndex = $driverMoney.findIndex((obj => obj.id === id));
            return  $driverMoney[objIndex].money
        }
        else {
            return '';
        }
    }
    onPayButtonClick = () => {
        let $driverMoney = this.state.driverMoney;
        if(!$driverMoney) {
            toast.error('مبالغ واریزی را وارد کنید')
            return  false
        }
        const request = {
            driverMoney : $driverMoney
        }
        API.setDriversPayment(request)
            .then((response) => {
    /*            this.setState({owners : response.results.owners , request : response.results.request})
                this.setState({ isLoaded : true})*/
                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)

            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });
    }
    render() {
        return (
            <React.Fragment>
                {!this.state.isLoaded ? <Loading/> :''}
                <Toast/>
                <Actionbar noBack={0} title='لیست مالکین خودروها'/>
                <section className="container p-4 rtl my-5">
                    <div className="row my-3">
                        <div className="col-12 alert alert-primary text-center super-small fw-bold">
                            تخصیص مربوط به مالک:
                            &nbsp;
                            {this.state.owner}
                        </div>

                    </div>
                    {
                        this.state.drivers.map(driver => {

                            return (
                                <div className='row driver-row' key={driver.id}
                                     onClick={() => {this.props.history.push('/owners/' + driver.id) }}
                                >
                                    <div className="col-2">
                                        <img src={driver.avatar} alt="avatar" className='w-100 rounded-more'/>
                                    </div>
                                    <div className="col-10 pt-2 fw-bold">
                                        {driver.full_name}

                                    </div>
                                    <div className="col-12 mt-4">
                                        <div className="form-floating mb-3 ">
                                            <input type="number" className="form-control w-100" id="floatingInput"
                                                   placeholder="name@example.com"
                                                   value={this.getPayAmount(driver.id)}
                                                   onChange={(val) => {
                                                       this.updatePayAmount(driver.id ,val.target.value )
                                                   }}
                                            />
                                            <label htmlFor="floatingInput">
                                                مبلغ واریز شده
                                            (ریال)
                                            </label>
                                        </div>
                                        <div className='text-center fw-bold super-small mt-2'>

                                                {currencyFormat.format( this.getPayAmount(driver.id) / 10) }
                                               &nbsp;
                                            تومان

                                        </div>
                                    </div>
                                  </div>

                            )

                        })
                    }
                    <div className="w-100 fixed-bottom max-w-lg pb-2">
                        <button onClick={this.onPayButtonClick} disabled={this.state.buttonStatus} type="submit"
                                className="btn btn-success w-100 py-2">
                           ثبت واریزی
                            <span  className={"spinner-grow spinner-grow-sm " + this.state.loading} role="status"
                                   aria-hidden="true"></span>
                        </button>
                    </div>
                </section>

            </React.Fragment>
        );
    }
    componentDidMount() {
        const request = {
            owner_id : this.props.match.params.id
        }
        API.getOwnerDrivers(request)
            .then((response) => {
                this.setState({owner : response.results.owner , drivers : response.results.drivers})
                this.setState({ isLoaded : true})
                setTimeout (() => {
                    window.scrollTo({top: 0, behavior: 'smooth'});
                },400)

            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });
    }
}

export default Owner;